import { useSelector } from 'react-redux'
import { useCountdown } from '@hooks/useCountdown'
import { useTournamentOptIn } from '@hooks/queries/useTournaments'
import { useTournamentNavigation } from '@hooks/tournaments/useTournamentNavigation'
import {
  deriveTournamentCardView,
  deriveScheduleLabel,
  splitCountdown,
} from '@core/tournaments/tournamentCardView'
import TournamentCard from './TournamentCard'

// Owns every hook a tournament card needs (countdown, opt-in mutation,
// navigation, currency) so TournamentCard itself stays pure render. Reused
// for both the list card and the detail-screen card — same behavior, an
// `isDetail` flag into the derivation decides the footer/badge shape.
// Opt-in success just lets the mutation's registered `invalidates: [['tournaments']]`
// refetch the list — no forced back-navigation hack (defenderV2 chained two
// setTimeouts to force a return to the list after opting in).
const TournamentCardController = ({ tournament, origin, variant = 'list' }) => {
  const isDetail = variant === 'detail'
  const view = deriveTournamentCardView(tournament, origin, { isDetail })
  const schedule = deriveScheduleLabel(tournament?.timeFrom, tournament?.timeTo)
  const { remaining } = useCountdown(view?.showCountdown ? tournament?.rawEndDateTime : null)
  const countdown = view?.showCountdown ? splitCountdown(remaining) : null
  const { mutate: setOptIn, isPending } = useTournamentOptIn()
  const { onViewTournament } = useTournamentNavigation()
  const currencyCode = useSelector((state) => state.wallet.displayCurrencyCode)

  if (!tournament) return null

  return (
    <TournamentCard
      tournament={tournament}
      view={view}
      schedule={schedule}
      countdown={countdown}
      currencyCode={currencyCode}
      isSubmitting={isPending}
      onAccept={() => setOptIn({ tournamentId: tournament.id, optInStatus: true })}
      onDecline={() => setOptIn({ tournamentId: tournament.id, optInStatus: false })}
      onView={() => onViewTournament(tournament, origin)}
      variant={variant}
    />
  )
}

export default TournamentCardController
